module.exports = __webpack_public_path__ + "assets/ic_cart-80157b.svg";